import React from 'react'

import {
  SORT_FILTER_TRAIT_DATERANGE,
  SORT_FILTER_TRAIT_MULTIVALUE,
  SORT_FILTER_TRAIT_THREE_SIDED_BOOLEAN,
  SORT_FILTER_TRAIT_VALUE,
} from '../../constants'
import DefaultDateRangeFilter from '../DefaultDaterangeFilter'
import DefaultMultiSelectFilter from '../DefaultMultiSelectFilter'
import DefaultTextFilter from '../DefaultTextFilter'
import DefaultThreeSidedBooleanFilter from '../DefaultThreeSidedBooleanFilter'
import type { FilterRendererProps } from './filter-renderer'

const FilterRenderer = ({
  definition,
  sortFilter,
}: FilterRendererProps): React.ReactElement => {
  if ('component' in definition) {
    return React.createElement(definition.component, {
      sortFilter,
      ...definition.additionalProps,
    })
  }
  if (definition.type === SORT_FILTER_TRAIT_DATERANGE) {
    return (
      <DefaultDateRangeFilter
        sortFilter={sortFilter}
        filterDefinition={definition}
      />
    )
  }

  if (definition.type === SORT_FILTER_TRAIT_VALUE) {
    return (
      <DefaultTextFilter
        sortFilter={sortFilter}
        filterDefinition={definition}
      />
    )
  }

  if (definition.type === SORT_FILTER_TRAIT_THREE_SIDED_BOOLEAN) {
    return (
      <DefaultThreeSidedBooleanFilter
        sortFilter={sortFilter}
        filterDefinition={definition}
      />
    )
  }

  if (definition.type === SORT_FILTER_TRAIT_MULTIVALUE) {
    return (
      <DefaultMultiSelectFilter
        sortFilter={sortFilter}
        filterDefinition={definition}
      />
    )
  }

  return <></>
}

export default FilterRenderer
